import { useCallback, useEffect, useState } from "react";
import { fetchEmailStatus } from "@/api/email";
import type { EmailStatus } from "@/types/email";

export function useEmailStatus() {
  const [status, setStatus] = useState<EmailStatus | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const payload = await fetchEmailStatus();
      setStatus(payload ?? null);
    } catch (error) {
      setStatus(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      await refresh();
      if (cancelled) return;
    })();
    return () => {
      cancelled = true;
    };
  }, [refresh]);

  return { status, loading, refresh };
}
